package com.eladfinish.bible.contest.features.share

import org.koin.dsl.module

actual val sharePlatformModule = module {
    single<ShareLauncher> { WebShareLauncher(clipboardManager = get()) }
}
